import { BlockValueTemplateFieldArea } from '../../ConfigFields/CodeMirror/FlowTemplate';

export function TextBlockFormFields() {
  return (
    <BlockValueTemplateFieldArea
      fieldName="config.text"
      label="Output text"
      placeholder="Type text here"
      required={true}
    />
  );
}
